import nf from "@tuplo/numberfmt";

export const formatPrice = (price) => {
  return nf(price, "0,0.00", {
    locale: "en-US",
  });
};
